import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import useTitle from '../../../hooks/useTitle';

import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../../state/actions';

import { elements } from '../..';

const PageContainerExternal = ({ children, pageReady, pageTitle, sticky, shadow, goBackLink, cover, menu, pageRef, topPadding, pageFocusMenu }) => {

    const expandMenu = useSelector(state => state.nav.expandMenu)

    // const { updateSticky } = bindActionCreators(actions, useDispatch());
    // const { updateShadow } = bindActionCreators(actions, useDispatch());
    // const { updateMenu } = bindActionCreators(actions, useDispatch());
    // const { updatePageRef } = bindActionCreators(actions, useDispatch());
    // const { updatePageFocusMenu } = bindActionCreators(actions, useDispatch());
    // const { updateGoBackLink } = bindActionCreators(actions, useDispatch());

    useEffect(() => {
        // updateSticky(sticky)
        // updateShadow(shadow)
        // updateMenu(menu)
        // updatePageRef(pageRef)
        // updatePageFocusMenu(pageFocusMenu)
        // updateGoBackLink(goBackLink)

        // ~~~~~~~~~ DISABLE DEPENDENCY REQS ~~~~~~~~~ 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageFocusMenu])

    useTitle(pageTitle);

    return (

        <PageContainerStyled 
            cover={cover} 
            topPadding={topPadding}
            expandMenu={expandMenu}>

            {!pageReady ? 

                <elements.PageSpinner backgroundColor='#0092FF' color='#ffffff' size='large' /> 
                
                : (
                    <>
                        { children }
                    </>
                )
            }

        </PageContainerStyled>

    )

}



export default PageContainerExternal;

const PageContainerStyled = styled.div.attrs({ id: 'page-scroll' })`
    display:flex;
    width: 100%;
    flex-direction:column;
    position:relative;
    box-sizing:border-box;
    z-index:${props => props.cover ? '1' : '1'};
    transition: all 0.5s;
    overflow-x:hidden;
     scroll-snap-type: y mandatory;
    scroll-behavior: smooth;

    height: 100vh;              /* full viewport */
    overflow-y: auto;           /* <— important */
    -webkit-overflow-scrolling: touch;
`

   
